var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header__logo"},[_c('img',{attrs:{"alt":_vm.$t('img-alt.hotmart-logo'),"src":require("../../static/images/hotmart-logo.svg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }